// extracted by mini-css-extract-plugin
export default {"plot":"kPjt3HGH","minimap":"C32Ukzsn","legend":"Ped5JbVI","pill":"y5PL8qVL"};